// privatokonomi-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'pkn.ctl.avgOne': 'Average of income and outgoings over the last {count} month',
  'pkn.ctl.avgMany': 'Average of income and outgoings over the last {count} months',
  'pkn.ctl.missingIncomeData': 'Income and spending data is missing',
  'pkn.ctl.title': 'Financial control',
  'pkn.ctl.sub': 'Buffer, monthly room to manoeuvre and the quality of the data basis',
  'pkn.ctl.adjustBuffer': 'Adjust buffer',
  'pkn.ctl.missingSpendData': 'Spending data is missing',
  'pkn.ctl.bufferMonths': '{count} months of normal spending',
  'pkn.ctl.bufferTarget': 'Buffer target',
  'pkn.ctl.gapRemaining': '{amount} remaining',
  'pkn.ctl.targetCovered': 'The target is covered',
  'pkn.ctl.leftPerMonth': 'Left over per month',
  'pkn.ctl.missingData': 'Data missing',
  'pkn.ctl.coverageTitle': 'Data coverage and traceability',
  'pkn.ctl.lastUpdated': 'Last updated {date}',
  'pkn.ctl.coverageCounts': '{accounts} accounts · {transactions} transactions · {uncategorized} uncategorised',
  'pkn.ctl.missingMonths': 'missing {months}',
  'pkn.ctl.unlinkedImports': '{count} imports without an account',
  'pkn.ctl.duplicateImports': '{count} possible duplicate imports',
  'pkn.ctl.adjustTarget': 'Adjust buffer target',
  'pkn.ctl.autoHint': 'The automatic suggestion is three months of registered expenses.',
  'pkn.ctl.useAuto': 'Use automatic suggestion',
  'pkn.ctl.allTx': 'All transactions',
  'pkn.ctl.allTxSub': 'Search, filter, export and open a category to correct postings',
  'pkn.ctl.exportCsv': 'Export CSV',
  'pkn.ctl.searchTx': 'Search transactions',
  'pkn.ctl.type': 'Type',
  'pkn.ctl.allTypes': 'All types',
  'pkn.ctl.expense': 'Expense',
  'pkn.ctl.debtPayment': 'Debt payment',
  'pkn.ctl.transfer': 'Transfer',
  'pkn.ctl.allCategories': 'All categories',
  'pkn.ctl.noMatch': 'No transactions match the filters.',
  'pkn.ctl.transaction': 'Transaction',
  'pkn.ctl.other': 'Other',
  'pkn.eie.type.cash': 'Cash and current account',
  'pkn.eie.type.savings': 'Buffer and savings account',
  'pkn.eie.type.fund': 'Funds',
  'pkn.eie.type.shares': 'Shares',
  'pkn.eie.type.other-investment': 'Other investments',
  'pkn.eie.type.property': 'Property',
  'pkn.eie.type.vehicle': 'Vehicle',
  'pkn.eie.type.collectible': 'Collectibles',
  'pkn.eie.type.other': 'Other',
  'pkn.eie.icon.home': 'Property',
  'pkn.eie.icon.car': 'Vehicle',
  'pkn.eie.icon.building': 'Holiday property',
  'pkn.eie.icon.wallet': 'Savings',
  'pkn.eie.icon.trendUp': 'Funds / shares',
  'pkn.eie.icon.sparkle': 'Valuables',
  'pkn.eie.health.riskLabel': 'High risk',
  'pkn.eie.health.riskNote': 'The value is expected to fall quickly',
  'pkn.eie.health.pressLabel': 'Under pressure',
  'pkn.eie.health.pressNote': 'Growing more slowly than inflation',
  'pkn.eie.health.strongLabel': 'Strong investment',
  'pkn.eie.health.strongNote': 'Good returns over time',
  'pkn.eie.health.stableLabel': 'Stable',
  'pkn.eie.health.stableNote': 'Steady and predictable value',
  'pkn.eie.factor.diversification': 'Diversification',
  'pkn.eie.factor.diversificationNote': 'Spread across different types of assets',
  'pkn.eie.factor.liquidity': 'Liquidity',
  'pkn.eie.factor.liquidityNote': 'Share you can quickly turn into cash',
  'pkn.eie.factor.risk': 'Risk level',
  'pkn.eie.factor.riskNote': 'How much is held in assets that fall quickly',
  'pkn.eie.factor.leverage': 'Debt ratio',
  'pkn.eie.factor.leverageNote': 'Equity relative to debt',
  'pkn.eie.expectedPerMonth': 'expected per month',
  'pkn.eie.expectedToChange': 'is expected to change',
  'pkn.eie.perYearWithValue': 'per year. With a value of {value} that corresponds to roughly {amount} {kind} each month.',
  'pkn.eie.valueFall': 'in lost value',
  'pkn.eie.valueGrowth': 'in value growth',
  'pkn.eie.projectionNote': 'The projection below uses your own expectation for annual change in value. Plumme does not yet fetch market data for homes, used cars or funds — once that is in place, I will update the estimate automatically.',
  'pkn.eie.fillNameValue': 'Enter a name and value',
  'pkn.eie.editAsset': 'Edit asset',
  'pkn.eie.addAsset': 'Add asset',
  'pkn.eie.fieldName': 'Asset name',
  'pkn.eie.phName': 'E.g. Detached house',
  'pkn.eie.fieldDetail': 'Description',
  'pkn.eie.phDetail': 'E.g. address, model year or provider',
  'pkn.eie.fieldValue': 'Sale value/market value today (kr)',
  'pkn.eie.fieldTaxValue': 'Taxable net wealth value (kr)',
  'pkn.eie.fieldGrowth': 'Expected change in value per year (%)',
  'pkn.eie.phGrowth': 'e.g. 3.5 or −12',
  'pkn.eie.assetType': 'Asset type',
  'pkn.eie.pickColor': 'Choose colour {color}',
  'pkn.eie.taxBasis': 'Taxable value {amount}',
  'pkn.eie.perYearSuffix': '/yr',
  'pkn.eie.notRegistered': 'Not registered',
  'pkn.eie.liquidSub': 'Bank/cash {cash} · investments {investments}',
  'pkn.eie.liquidNote': 'Liquid wealth is money in accounts and funds/shares that can normally be sold. The buffer assessment only uses bank and cash, because investments can fluctuate in value.',
  'pkn.eie.verdict.solid': 'Solid and well-balanced wealth',
  'pkn.eie.verdict.healthy': 'Healthy wealth with room for adjustment',
  'pkn.eie.verdict.rebalance': 'Your wealth should be balanced better',
  'pkn.eie.watchMostPrefix': 'What I am keeping the closest eye on is',
  'pkn.eie.mostRoom': 'this is where there is the most room to strengthen your wealth.',
  'pkn.eie.fineButBetter': 'which is fine, but could be even better.',
  'pkn.eie.perMonth': 'per month',
  'pkn.eie.monthlyForecastNote': 'per month. When market data is connected, I will update the estimate automatically against the housing, used-car and fund markets.',
  'pkn.eie.valueToday': 'The value today is {value}.',
  'pkn.eie.watchClear': 'None of your assets need extra attention right now. Everything looks healthy and balanced based on the assumptions you have entered.',
  'pkn.eie.fallWarn': 'The value is expected to fall {pct} per year.',
  'pkn.eie.slowWarn': 'Growing more slowly than inflation ({pct} per year).',
  'pkn.eie.monthlyEquiv': 'That corresponds to {amount} per month.',
  'pkn.eie.empty': 'No assets registered yet. Press "Add asset" to register a house, car, boat, cabin, art, savings, funds and more.',
  'pkn.fam.fair.even': 'Evenly split',
  'pkn.fam.fair.slightly': 'Slightly lopsided',
  'pkn.fam.fair.uneven': 'Lopsided',
  'pkn.fam.needTwo': 'Enter at least two people with income and share of shared costs, and I will compare the split against the income share.',
  'pkn.fam.perMonthShort': '/ mo',
  'pkn.fam.ofSharedCosts': '{pct} % of the shared costs',
  'pkn.fam.ofIncome': '{pct} % of the income',
  'pkn.fam.evenSuffix': 'in shared costs every month, and each of you covers roughly the share your income suggests.',
  'pkn.fam.uneven': 'covers {costShare} % of the shared costs but accounts for {incomeShare} % of the income. A split by income would give {amount} per month — that is {diff} {direction} than today. What is right is for you to decide; this is just the arithmetic.',
  'pkn.fam.less': 'less',
  'pkn.fam.more': 'more',
  'pkn.fam.idea.bufferTitle': 'Build a shared buffer fund',
  'pkn.fam.idea.bufferText': 'After shared costs the household has {left} left every month. If you set aside 10 % of this — {monthly} per month — you will have {yearly} in buffer in a year.',
  'pkn.fam.metricPerMonth': '{amount}/mo',
  'pkn.fam.idea.keyTitle': 'Agree on the split key',
  'pkn.fam.idea.keyText': 'The split of shared costs deviates by more than 15 percentage points from the income share. Many choose either an equal split or a split by income — the important thing is that you have chosen deliberately.',
  'pkn.fam.metricDeviation': '{pp} pp deviation',
  'pkn.fam.idea.reviewTitle': 'Review the shared costs together',
  'pkn.fam.idea.reviewText': 'You pay {monthly} in shared costs every month, which is {yearly} a year. Set aside an evening to go through subscriptions, insurance and the electricity contract together — that is where most people find the most.',
  'pkn.fam.metricPerYear': '{amount}/yr',
  'pkn.fam.ideasEmpty': 'Once you have entered income and shared costs, I will suggest concrete steps you can take together.',
  'pkn.fam.editPerson': 'Edit person',
  'pkn.fam.addPerson': 'Add person',
  'pkn.fam.goToMyPage': 'Go to My page',
  'pkn.fam.devMode': 'Development mode: You are not connected to a partner yet. Data you register here stays in your own Personal finance client. Link two separate accounts on My page to share the Family profile.',
  'pkn.fam.askSuperPlumma': 'Ask SuperPlumma',
  'pkn.fam.connectedEmpty': 'You are linked. Enter the information you want to share in order to compare income share and share of the shared costs.',
  'pkn.fam.subShared': 'Shared between the linked Personal finance accounts',
  'pkn.fam.subLocal': 'Local development view · not shared',
  'pkn.fam.cardSub': 'shared costs / mo · income {income}',
  'pkn.fam.cardShares': '{income} % of income · {costs} % of shared costs',
  'pkn.fam.householdSuffix': 'in shared costs per month. Compare the cost share with the income share to assess the split.',
  'pkn.for.tone.over': 'Over budget',
  'pkn.for.tone.near': 'Getting close',
  'pkn.for.tone.within': 'Within budget',
  'pkn.for.noImportedMonth': 'No imported transactions this month',
  'pkn.for.plannedIncome': 'Planned income',
  'pkn.for.incomeHint': 'Use gross salary and tax percentage when you know the agreed salary. Net is what you expect to receive in your account.',
  'pkn.for.grossPerMonth': 'Gross per month',
  'pkn.for.netToAccount': 'Net into account',
  'pkn.for.limitHint': 'The limit is set per main category. Your own categories below are added on top.',
  'pkn.for.used': 'used {amount}',
  'pkn.for.showAsGroup': 'Show as its own main category in "Where the money goes"',
  'pkn.for.budgetUpdated': 'The budget has been updated',
  'pkn.for.gross': '{amount} gross',
  'pkn.for.taxPct': '{pct} % tax',
  'pkn.for.netPerMonth': 'Net per month',
  'pkn.for.budgetUses': 'budget uses {pct} %',
  'pkn.for.noBudgets': 'You have not set a budget for any categories yet. Press "Adjust budget" to set a monthly limit — then I will keep watch and tell you when a category is getting close.',
  'pkn.for.budgetedInPeriod': 'budgeted in the period',
  'pkn.for.leftInPeriod': '{amount} left in the period',
  'pkn.for.overBudget': '{amount} over budget',
  'pkn.for.allWithin': 'All categories within budget',
  'pkn.for.overLimitOne': '{count} category over the limit',
  'pkn.for.overLimitMany': '{count} categories over the limit',
  'pkn.for.pctUsed': '{pct} % used',
  'pkn.for.diffLeft': '{amount} left',
  'pkn.for.diffOver': '{amount} over',
  'pkn.for.mainCategories': 'Main categories',
  'pkn.for.allCategories': 'All categories',
  'pkn.for.noSpendInPeriod': 'No spending registered in {period}. Choose another period, or upload the account statement for this month under Import.',
  'pkn.for.noSpendData': 'No spending data yet. Upload an account statement under Import, and I will read the transactions and categorise them automatically.',
  'pkn.for.highlight': 'Highlight {name} in the chart',
  'pkn.for.hideCats': 'Hide the categories in {name}',
  'pkn.for.showCats': 'Show the categories in {name}',
  'pkn.for.seeTx': 'See transactions in {name}',
  'pkn.for.ofGroupSuffix': '% of the group',
  'pkn.for.biggest': 'The largest {kind} is',
  'pkn.for.kindCost': 'cost category',
  'pkn.for.kindMain': 'main category',
  'pkn.for.biggestSuffix': 'with {amount} — {pct} % of the spending in the period.',
  'pkn.for.noRecurring': 'I have not found any recurring subscription charges yet. Once more months of account statements have been read in, I will list fixed charges with a calculated annual cost. You decide whether the service is still useful.',
  'pkn.for.recurringTotal': 'Recurring charges in the selected period amount to roughly {amount} per year.',
  'pkn.for.annualNote': 'This is an annual cost, not a promised saving. Check each charge before you change anything.',
  'pkn.for.confidence': 'Confidence {pct} %',
  'pkn.for.showTx': 'Show transactions',
  'pkn.for.yesSubscription': 'Yes, a subscription',
  'pkn.for.iUseIt': 'I use it',
  'pkn.for.iWantToCancel': 'I want to cancel',
  'pkn.for.remindLater': 'Remind me later',
  'pkn.fut.notSet': 'not set',
  'pkn.fut.notBeforeRetirement': 'not before retirement',
  'pkn.fut.status.reached': 'Reached',
  'pkn.fut.status.planned': 'Planned',
  'pkn.fut.status.noSaving': 'Missing savings amount',
  'pkn.fut.factor.progress': 'Progress towards goals',
  'pkn.fut.factor.progressNote': '{pct} % of the combined goal amount has been saved',
  'pkn.fut.factor.onPlan': 'Goals on plan',
  'pkn.fut.factor.onPlanNote': '{count} of {total} goals well on track',
  'pkn.fut.factor.autoBalance': 'Automatic balance',
  'pkn.fut.factor.autoBalanceNote': '{count} of {total} goals are linked to an account',
  'pkn.fut.life.goalReached': '{name} reached',
  'pkn.fut.life.netWorthPasses': 'Net wealth passes {amount}',
  'pkn.fut.life.retireAge': 'Retirement age {age}',
  'pkn.fut.impact.netWorth5': 'Net wealth in 5 years',
  'pkn.fut.impact.retireAge': 'Retirement age',
  'pkn.fut.ageYears': '{age} years',
  'pkn.fut.impact.savingToGoals': 'Saving towards goals',
  'pkn.fut.perMonth': '{amount}/mo',
  'pkn.fut.xOfY': '{count} of {total}',
  'pkn.fut.impact.debt': 'Debt',
  'pkn.fut.unchanged': 'Unchanged',
  'pkn.fut.goalSaved': 'The goal has been saved',
  'pkn.fut.eventSaved': 'The life event has been saved',
  'pkn.fut.enterAssumptions': 'Enter your own assumptions before Plumme makes forecasts.',
  'pkn.fut.noForecast': 'We do not show a personal forecast based on a default age, default return or assumed retirement age. Create the plan with your own figures first.',
  'pkn.fut.createPlan': 'Create future plan',
  'pkn.fut.horizon1': '1 yr',
  'pkn.fut.horizon5': '5 yrs',
  'pkn.fut.horizon10': '10 yrs',
  'pkn.fut.horizonRetirement': 'Retirement',
  'pkn.fut.reaches': 'is reached',
  'pkn.fut.expectedAtRetirement': 'Expected wealth at retirement ({age} years):',
  'pkn.fut.forMonths': 'for {count} mo',
  'pkn.fut.permanent': 'permanent',
  'pkn.fut.oneOff': '{amount} one-off',
  'pkn.fut.incoming': '{amount} in',
  'pkn.fut.switchOn': 'Switch on',
  'pkn.fut.switchOff': 'Switch off',
  'pkn.fut.eventRemoved': 'The life event has been removed',
  'pkn.fut.goalsOnTrackSuffix': 'goals on track · {pct} % overall progress',
  'pkn.fut.first': 'first',
  'pkn.fut.priorityBody': 'This goal needs the most attention in the plan. It is missing {amount}.',
  'pkn.fut.targetDate': 'With today\'s plan the calculated target date is {date}.',
  'pkn.fut.cannotCalcEnd': 'Cannot calculate an end date with the current savings amount',
  'pkn.fut.noGoals': 'You have no goals yet. Add your first — buffer, equity, holiday or something else — and I will work out when you will reach it and what gets you there faster.',
  'pkn.fut.planStatus': 'Plan status',
  'pkn.fut.action1': 'Set up a fixed transfer on payday',
  'pkn.fut.action2': 'Increase the monthly savings a little',
  'pkn.fut.action3': 'Move a lump sum here',
  'pkn.fut.reachesGoal': '{name} reaches the goal',
  'pkn.fut.amountLeft': '{amount} left',
  'pkn.fut.courseA': 'This is the course your finances are on with the plan you have entered',
  'pkn.fut.courseB': 'Every small adjustment — a little more saving, a refinancing, a cancelled subscription — moves the whole timeline closer.',
  'pkn.fut.goalDeleted': 'The goal has been deleted',
  'pkn.fut.deleteGoalBody': 'The progress of {amount} disappears from the overview, and the goal is removed from your forecast and life plan.',
  'pkn.fut.familyIntro': 'Family finance shows who in the household pays what, how you compare with each other, and how fair the split is relative to income. To work that out I need household members and ownership on the transactions — that is connected in a later step.',
  'pkn.fut.noMembers': 'No household members have been registered yet. Once the household is set up and the transactions have ownership, I will show the costs per person, compare spending category by category and work out how fair the split of shared costs is.',
  'pkn.fut.personalSpend': 'Personal spending · you vs. partner',
  'pkn.fut.splitOne': 'per month split across {count} person.',
  'pkn.fut.splitMany': 'per month split across {count} people.',
  'pkn.gj.icon.card': 'Card/consumer',
  'pkn.gj.icon.home': 'Housing',
  'pkn.gj.icon.car': 'Car',
  'pkn.gj.icon.bank': 'Bank/student',
  'pkn.gj.never': 'Never',
  'pkn.gj.monthsShort': '{count} mo',
  'pkn.gj.yearsShort': '{count} yrs',
  'pkn.gj.health.expensiveLabel': 'Expensive debt',
  'pkn.gj.health.expensiveNote': 'Interest above 12 % — check refinancing',
  'pkn.gj.health.highLabel': 'High interest',
  'pkn.gj.health.highNote': 'Interest above 8 %',
  'pkn.gj.health.lowLabel': 'Low interest',
  'pkn.gj.health.lowNote': 'Affordable debt',
  'pkn.gj.health.okLabel': 'Fair interest',
  'pkn.gj.health.okNote': 'Normal interest level',
  'pkn.gj.journey.paidOff': '{name} paid off',
  'pkn.gj.journey.half': 'Half of {name} paid off',
});
